export const FontFamily = {
    regular: 'Manrope-Regular',
    medium: 'Manrope-Medium',
    semiBold: 'Manrope-SemiBold',
    bold: 'Manrope-Bold',
    light: 'Manrope-Light',
    extraBold: 'Manrope-ExtraBold',
    extraLight: 'Manrope-ExtraLight'
};
